(function () {
  var HIDE_STRINGS = ['from Amazon', 'on Amazon', 'From Amazon', 'On Amazon'];

  var HIDE_CSS =
    '[class*="attribution"],[class*="branding"],[class*="source"],' +
    '[class*="powered"],[class*="amazon-link"],[class*="on-amazon"],' +
    'a[href*="amazon.com/dp"],a[href*="amazon.com/product"]' +
    '{ display:none!important }';

  // Star rating widget — Rift bold uppercase to match product-info label style
  var RATING_CSS =
    ':host, * { font-family: "Rift", sans-serif !important; font-weight: 700 !important; ' +
    'font-size: 0.875rem !important; letter-spacing: 0.12em !important; ' +
    'text-transform: uppercase !important; color: rgba(23,23,23,0.65) !important; }';

  // Full reviews section — Gotham readable body text
  // Heading forced to span full widget width, flush left, above the rating columns
  var REVIEWS_CSS =
    ':host { padding: 0 !important; margin: 0 !important; }' +
    ':host, * { font-family: "Gotham", sans-serif !important; font-weight: 400 !important; ' +
    'font-size: var(--text-sm) !important; letter-spacing: normal !important; ' +
    'color: rgba(23,23,23,0.85) !important; }' +
    'h1, h2, h3 { ' +
    '  grid-column: 1 / -1 !important; flex-basis: 100% !important; ' +
    '  width: 100% !important; max-width: 100% !important; ' +
    '  text-align: left !important; ' +
    '  margin: 0 0 1rem 0 !important; padding: 0 !important; ' +
    '  order: -1 !important; align-self: start !important; ' +
    '}';

  function patchRoot(root, tag) {
    var style = document.createElement('style');
    style.textContent =
      (tag === 'amazon-product-rating' ? RATING_CSS : REVIEWS_CSS) + HIDE_CSS;
    root.appendChild(style);

    function processText() {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        var val = node.nodeValue || '';
        // Hide Amazon attribution text
        if (HIDE_STRINGS.some(function (s) { return val.indexOf(s) !== -1; })) {
          var parent = node.parentElement;
          if (parent) parent.style.setProperty('display', 'none', 'important');
        }
        // Suppress "bought in past month" count entirely
        if (tag === 'amazon-product-rating' && val.toLowerCase().indexOf('bought') !== -1 &&
            (val.toLowerCase().indexOf('month') !== -1 || val.toLowerCase().indexOf('past') !== -1 || val.toLowerCase().indexOf('last') !== -1)) {
          var sourceEl = node.parentElement;
          if (sourceEl) sourceEl.style.setProperty('display', 'none', 'important');
        }
      }
    }

    new MutationObserver(processText).observe(root, { childList: true, subtree: true });
    processText();
  }

  // === KEY: intercept attachShadow before Amazon scripts run ===
  var _attachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    var root = _attachShadow.call(this, Object.assign({}, init, { mode: 'open' }));
    var el = this;
    setTimeout(function () {
      var tag = el.tagName && el.tagName.toLowerCase();
      if (tag === 'amazon-product-rating' || tag === 'amazon-product-reviews') {
        patchRoot(root, tag);
      }
    }, 0);
    return root;
  };

  // Fallback: catch any roots that were already open
  function processExisting() {
    ['amazon-product-rating', 'amazon-product-reviews'].forEach(function (tag) {
      document.querySelectorAll(tag).forEach(function (el) {
        if (el.shadowRoot) patchRoot(el.shadowRoot, tag);
      });
    });
  }
  setTimeout(processExisting, 500);
  setTimeout(processExisting, 2000);
})();
